
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 33 26","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#fff","fill-rule":"nonzero","d":"M4.2 10.369l7.688 7.69L29.02.921l3.954 3.955-.33.33-20.756 20.65L.247 14.213z"}})])
      }
    
      }
    